import { API_GATEWAY } from 'constants/appConstants'
import apiClient from 'services/axiosApp'
import store from 'store/store'
import Utils from 'utils/Utils'

const ContactsAPI = {
  getList: (companyID, contactType, page = 1) => {
    const queryParam = {
      params: {
        contact_type: contactType,
        company_id: !companyID ? null : companyID,
        page,
      },
    }
    return apiClient.get('/api/v3/contacts', queryParam)
  },
  getListBySearch: (query) => {
    const queryParam = {
      params: {
        page: 1,
        per_page: 10,
        ...query,
      },
      ...Utils.paramToCatalog(),
    }
    return apiClient.get(`${API_GATEWAY}/v1/catalog/contacts/search`, queryParam)
  },
  create: (contact) => apiClient.post('/api/v3/contacts', contact),
  delete: (contactID) => apiClient.delete(`/api/v3/contacts/${contactID}`),
  update: (contact) => apiClient.put(`/api/v3/contacts/${contact.id}`, contact),
  search: async ({ searchText, companyID, contactType, only, callback }) => {
    const res = await apiClient.get(`${API_GATEWAY}/v1/catalog/contacts/search`, {
      params: {
        contact_type: contactType,
        company_id: !companyID ? null : companyID,
        search_text: searchText,
        only: only,
      },
      ...Utils.paramToCatalog(),
    })
    return callback(res)
  },
  get: ({ id, only = [] }) =>
    apiClient.get(`${API_GATEWAY}/v1/catalog/contacts/${id}`, {
      params: {
        only: only,
      },
      ...Utils.paramToCatalog(),
    }),
  deleteMultiple: (payload) =>
    apiClient.delete(`/api/v3/contacts/delete_contacts`, {
      data: payload,
    }),
  copyContact: (payload) => apiClient.post(`/api/v3/contacts/copy`, payload),
  downloadTemplate: () =>
    apiClient.get('/api/v3/contacts/download_template', {
      responseType: 'blob',
    }),
  uploadFileContact: (formData) =>
    apiClient.post('/api/v3/contacts/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
}

export default ContactsAPI
